import { useEffect, useState } from "react";
import { _BankAccount, _CompetitionType, _Entailment, _MainTheme, _PaymentType, _single, _StrategicObjetive, _ThirdBankingAccount } from "../../../../core/services/dataBean/EntityCatalog";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";

import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { CompanyEditor } from "../Company/CompanyEditor";
import { BakingEntityEditor } from "../BankingEntity/BankingEntitySelect";
import { BankingAccountEditor } from "../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/BankingAccountSelect";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBusinessCore } from "../BusinessCore/SelectBusinessCore";

export const BankAccountCatalog = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_BankAccount);

    const [idCompany, setidCompany] = useState<number>(null)
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idCompany])

    const getLista = () => {

        instance.getBankingAccountCatalog(idCompany).then(
            (resp: any) => {
                if (resp) {
                    let List = resp;
                    List.forEach((e: any) => {

                        e.DataBeanProperties.BankingNameCode = (e.DataBeanProperties.BankingEntityCode ?? '') +
                            (e.DataBeanProperties.BankingEntityName ?? '')


                    })
                    setLista(List);
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const create = () => {
        setBean({
            IDCompany: idCompany
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        instance.deleteBankingAccount(bean.IDBankingAccount).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        instance.updateBankingAccount(bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDBankingAccount', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Entidad Bancaria', property: 'BankingNameCode', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Sucursal', property: 'IDBranch', visible: true },
        { title: 'Tipo Cuenta', property: 'AccountTypeName', visible: true },
        { title: 'Número Cuenta', property: 'AccountNumber', visible: true },
        { title: 'Cuenta Débito', property: 'AccountantIDName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem()
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "IDBankingEntity", "AccountantIDStr", "IDBusinessCore", "Name", "IDBranch", "AccountType", "AccountNumber"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };


    return (
        <BasicPage titulo="Cuentas Bancarias de la Organización">
            <div className="row">
                <div className="col-md-12">
                    <CompanyEditor id={idCompany} onchange={(e) => { setidCompany(e) }} />
                </div>


            </div>
            <div className="row">
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDBankingEntity') ? 'has-error' : ''}`}>Entidad Bancaria</label>
                                <BakingEntityEditor label=" " idSelector={bean.IDBankingEntity} onChange={(e) => { setBean({ ...bean, "IDBankingEntity": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('AccountantIDStr') ? 'has-error' : ''}`}>Cuenta Débito</label>
                                <SelectAccountantTree label=" " jsonCode={bean.AccountantIDStr} onChange={(e) => { setBean({ ...bean, "AccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDBusinessCore') ? 'has-error' : ''}`}>Unidad de Negocio</label>
                                <SelectBusinessCore label=' ' returnType="Object" idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e.IDBusinessCore, "BusinessCoreCodeName": `${e.Code} - ${e.Name}` }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`}>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDBranch') ? 'has-error' : ''}`}>Sucursal</label>
                                <input type="text" name="IDBranch" className="form-control" value={bean.IDBranch} onChange={(e) => { setBean({ ...bean, IDBranch: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('AccountType') ? 'has-error' : ''}`}>Tipo de Cuenta</label>
                                <BankingAccountEditor label=" " idSelector={bean.AccountType} onChange={(e) => { setBean({ ...bean, "AccountType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('AccountNumber') ? 'has-error' : ''}`}>Número Cuenta</label>
                                <input type="text" name="AccountNumber" className="form-control" value={bean.AccountNumber} onChange={(e) => { setBean({ ...bean, AccountNumber: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}